var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSouthkorea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 511.999C397.385 511.999 512 397.384 512 255.999C512 114.614 397.385 -0.000976562 256 -0.000976562C114.615 -0.000976562 0 114.614 0 255.999C0 397.384 114.615 511.999 256 511.999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.043 255.999C345.043 278.26 305.177 333.912 256 333.912C206.823 333.912 166.957 278.26 166.957 255.999C166.957 206.821 206.823 166.956 256 166.956C305.177 166.956 345.043 206.821 345.043 255.999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.043 255.999C345.043 305.177 305.177 345.042 256 345.042C206.823 345.042 166.957 305.177 166.957 255.999",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.375 334.707L373.982 311.1L389.72 326.838L366.113 350.446L350.375 334.707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.017 374.054L334.625 350.447L350.363 366.185L326.756 389.793L311.017 374.054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.593 381.92L421.201 358.312L436.939 374.051L413.332 397.658L397.593 381.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.237 421.273L381.844 397.666L397.583 413.404L373.975 437.012L358.237 421.273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.983 358.315L397.59 334.708L413.329 350.447L389.721 374.054L373.983 358.315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.636 397.662L358.244 374.054L373.982 389.793L350.375 413.4L334.636 397.662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.697 177.334L334.744 114.381L350.482 98.6423L413.436 161.596L397.697 177.334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.732 161.602L311.125 137.995L326.863 122.257L350.47 145.864L334.732 161.602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.079 200.958L350.471 177.35L366.209 161.613L389.816 185.22L374.079 200.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.942 114.379L358.335 90.7712L374.073 75.0327L397.681 98.6401L381.942 114.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.31 153.739L397.703 130.132L413.441 114.393L437.049 138.001L421.31 153.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7544 358.271L153.708 421.224L137.969 436.963L75.0159 374.01L90.7544 358.271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.705 373.997L177.312 397.605L161.574 413.342L137.967 389.735L153.705 373.997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.355 334.658L137.962 358.266L122.224 374.004L98.6165 350.397L114.355 334.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.965 311.044L200.919 373.998L185.18 389.736L122.227 326.783L137.965 311.044Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.701 90.7227L90.7478 153.676L75.0092 137.938L137.963 74.9841L153.701 90.7227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.309 114.327L114.356 177.281L98.6172 161.542L161.571 98.5889L177.309 114.327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.938 137.949L137.985 200.903L122.247 185.165L185.201 122.211L200.938 137.949Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_2476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthkorea);
export default __webpack_public_path__ + "static/media/southkorea.cd044ae0b4e5eef53a678de610d2be87.svg";
export { ForwardRef as ReactComponent };